import type { Revision, RevisionPageDocument } from '../../types';
import { mutations } from '../../utils';
import { getPageChildrenInRevision } from './getPageChildrenInRevision';
import { getRootPagesInRevision } from './getRootPagesInRevision';
import { isRevisionPageDocument, isRevisionPageGroup } from './guards';

/**
 * Locate the first RevisionPageDocument in the given Revision.
 */
export function getFirstPageDocumentInRevision(
    revision: Revision,
    parentKey?: string
): RevisionPageDocument | null;
export function getFirstPageDocumentInRevision(
    revision: mutations.MutableData<Revision>,
    parentKey?: string
): mutations.MutableData<RevisionPageDocument> | null;
export function getFirstPageDocumentInRevision(
    revision: mutations.MutableData<Revision>,
    parentKey?: string
): mutations.MutableData<RevisionPageDocument> | null {
    const pages = parentKey
        ? getPageChildrenInRevision(revision, parentKey)
        : getRootPagesInRevision(revision);

    for (const page of pages) {
        if (isRevisionPageDocument(page)) {
            return page;
        }

        if (isRevisionPageGroup(page)) {
            const document = getFirstPageDocumentInRevision(revision, mutations.get(page, 'id'));
            if (document) {
                return document;
            }
        }
    }

    return null;
}
